
import { Component, Ref, InjectReactive, Mixins } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui";
import UploadImg from "@/components/uploadImg.vue";
import { cloneDeep, debounce, uniqWith } from "lodash";
import { IHomeInstance } from "@/types/global";
import { getStoreListByMerchant } from "@/api/store";
import { getMerchantDetail, saveOrUpdateMerchant, getMerchant } from "@/api/prescriptionDb";
import { detectionTypeList } from "@/api/appCompose";

const initFormData = {
    id: "",
    name: "", // 品牌商名称
    stores: [], // 这里先放个 prop 给form 的rule使用
    contact: "", // 负责人
    phone: "",
    status: false,
    autoRegisterUser: false,
    allowUseQrcode: false,
    isShow: true,
    useCustomPres: 31,
    nursePres: 0,
    choiceMerchantId: "",
    defaultImgStatus: false,
    isShowImg: false,
    defaultImgUrl: [],
    remark: "", // 备注
    apiAppKey: "",
    apiAppSecret: "",
    apiStore: "",
    logoImgUrl: [],
    chineseMedicineLogo: [],
    companyName: "",
    backgroundImgUrl: [],
    appImgUrl: [],
    symptomsStatus: 0,
    healthRecordsSwitch: false,
    replaceMallSwitch: false,
    insteadMenu: "",
    insteadAddress: "",
    healthId: "",
    careId: "",
    wsUseBaseStore: 0,
    wsSymptom: 0,
    mixSySymptom: 1,
    enableWeigherV2: 1, // AI评估-体重管理报告类型：0.旧报告 1.新报告（新增品牌方默认为新报告）
    weigherPresLibName: 1, // 新报告处方库：1.舌诊+体脂 2.体质+体脂
    mixYdSymptom: 0, // 0.体质 1.舌诊
    symptomsForPres: 0, // 舌诊报告处方库对应症状选择：0.舌诊 1.体质
    wsAppBackImg: [],
    wsBigTitleImg: [],
    wsRatioImg: [],
    wsTopImg: [],

    wsMainLogo: [],
    wsBgImg: [],
    wsCountImg: [],
    wsTongueImg: [],
    showName: "",

    homepageMainTitle: "数智(AI)健康服务系统", // 首页主标题
    homepageSubTitle: "DIGITAL INTELLIGENCE (AI) HEALTH SERVICE SYSTEM", // 首页副标题
    homePageType: "", // 首页类型

    tongueApiQps: undefined,
    withDrawStoreId: "",

    // NOTE: 舌诊拍摄方式控制配置
    medicineBrainTongueShootMode: 1, // 中医大脑舌诊：1.AI智慧屏拍摄（默认） 2.手机拍摄
    wsTongueShootMode: 2, // 望舌知康APP舌诊：1.智慧屏拍摄（默认） 2.手机拍摄
}

@Component({
    components: {
        UploadImg
    }
})
export default class interfaceManage extends Mixins(loading) {
    @Ref("validateForm") readonly validateFormRef !: Form;
    @Ref("editBox") readonly editBoxRef !: HTMLElement;
    @InjectReactive() HomeInstance !: IHomeInstance;

    merchantId = this.$route.query.merchantId || "";
    brandName = this.$route.query.brandName || "";

    // NOTE: 锚点导航分组，id 与模板中 form-section 的 id（anchor-xxx）一一对应
    anchorList = [
        { id: "brain", label: "中医大脑" },
        { id: "mini", label: "智养小程序" },
        { id: "wsApp", label: "望舌知康APP" },
        { id: "wsMini", label: "望舌知康小程序" },
    ];
    activeAnchor = "brain";
    // NOTE: 锚点平滑滚动期间锁定 scrollspy，避免滚动过程中高亮闪烁
    isAnchorScrolling = false;
    anchorScrollTimer: number | null = null;

    storeInfo = []; // 关联门店数据
    saveLoading = false;
    merchantStoreSelectLoading = false;
    allMerchantStoreList = [];
    allMerchantOptions = []; // 把所有的品牌方列表cu存储一份c
    merchantOptions = []; // 品牌方列表
    userLoading = false;

    pageTypeList = [];

    defaultImgStatusStoreInfo = []; // 展示默认头像门店
    isShowImgStoreInfo = []; // 头像展示门店
    defaultImgStoreShowCount = 20; // 默认头像门店展示数量
    isShowImgStoreShowCount = 20; // 头像展示门店展示数量

    formData = {
        id: "",
        name: "", // 品牌商名称
        stores: [], // 这里先放个 prop 给form 的rule使用
        contact: "", // 负责人
        phone: "",
        status: false,
        autoRegisterUser: false,
        allowUseQrcode: false,
        isShow: true,
        useCustomPres: 31,
        nursePres: 0,
        choiceMerchantId: "",
        defaultImgStatus: false,
        isShowImg: false,
        defaultImgUrl: [],
        remark: "", // 备注
        apiAppKey: "",
        apiAppSecret: "",
        apiStore: "",
        logoImgUrl: [],
        chineseMedicineLogo: [],
        companyName: "",
        backgroundImgUrl: [],
        appImgUrl: [],
        symptomsStatus: 0,
        healthRecordsSwitch: false,
        replaceMallSwitch: false,
        insteadMenu: "",
        insteadAddress: "",
        bookStatus: false,
        healthId: "",
        careId: "",
        wsUseBaseStore: 0,
        wsBaseStoreId: "",
        wsSymptom: 0,
        mixSySymptom: 1,
        enableWeigherV2: 1, // AI评估-体重管理报告类型：0.旧报告 1.新报告（新增品牌方默认为新报告）
        weigherPresLibName: 1, // 新报告处方库：1.舌诊+体脂 2.体质+体脂
        mixYdSymptom: 0, // 0.体质 1.舌诊
        symptomsForPres: 0,
        usedMerchantList: [],
        homepageMainTitle: "数智(AI)健康服务系统", // 首页主标题
        homepageSubTitle: "DIGITAL INTELLIGENCE (AI) HEALTH SERVICE SYSTEM", // 首页副标题
        homePageType: "", // 首页类型
        wsAppBackImg: [],
        wsBigTitleImg: [],
        wsRatioImg: [],
        wsTopImg: [],

        wsMainLogo: [],
        wsBgImg: [],
        wsCountImg: [],
        wsTongueImg: [],

        showName: "",
        tongueApiQps: undefined,
        withDrawStoreId: "",

        // NOTE: 舌诊拍摄方式控制配置
        medicineBrainTongueShootMode: 1, // 中医大脑舌诊：1.AI智慧屏拍摄（默认） 2.手机拍摄
        wsTongueShootMode: 2, // 望舌知康APP舌诊：1.智慧屏拍摄（默认） 2.手机拍摄
    };

    formRules = {
        homepageMainTitle: [{ required: true, message: "请输入首页主标题", trigger: "blur" }],
        homePageType: [{ required: true, message: "请选择首页类型", trigger: "change", validator: this.validateHomepageType }],
    };

    // NOTE: 首页类型「经典首页」对应空值，校验器放行空值（保持与原编辑页逻辑一致）
    validateHomepageType(rule, value, callback) {
        callback();
    }

    mounted() {
        this.getMerchantList("");
        // 先加载门店列表，再加载详情（详情需要门店列表做ID→名称映射）
        getStoreListByMerchant({ merchantId: this.merchantId }).then((res) => {
            this.allMerchantStoreList = res.data;
            this.getMerchantDetail();
        });
        this.getPageTypeList();
    }

    beforeDestroy() {
        if (this.anchorScrollTimer) {
            clearTimeout(this.anchorScrollTimer);
            this.anchorScrollTimer = null;
        }
    }

    getPageTypeList() {
        detectionTypeList().then((res) => {
            this.pageTypeList = res.data || [];
        })
    }

    getMerchantListRemote = debounce(function(merchantName) {
        this.userLoading = true;
        getMerchant({ merchantId: this.merchantId, name: merchantName }).then((res) => {
            this.userLoading = false;
            this.merchantOptions = res.data;
            if (merchantName == "") {
                this.allMerchantOptions = res.data;
            }
        }).catch((err) => { this.userLoading = false; });
    })

    getMerchantList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantListRemote(str)
    }

    getMerchantStoreRemote = debounce(function (str) {
        this.merchantStoreSelectLoading = true;
        getStoreListByMerchant({merchantId: this.merchantId, name: str}).then((res) => {
          this.merchantStoreSelectLoading = false;
          this.allMerchantStoreList = res.data;
        }).catch((err) => {}).finally(() => {
            this.merchantStoreSelectLoading = false;
        });
    })

    getMerchantStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantStoreRemote(str)
    }

    getMerchantDetail() {
        if (!this.merchantId) {
            return;
        }
        getMerchantDetail(this.merchantId).then((res) => {
            const { stores, status, autoRegisterUser, allowUseQrcode, isShow, defaultImgStatus, isShowImg, healthRecordsSwitch, replaceMallSwitch, bookStatus, wsBaseStoreId, usedMerchantList, tongueApiQps } = res.data;

            Object.assign(this.formData, { ...res.data, status: Boolean(status), autoRegisterUser: Boolean(autoRegisterUser), allowUseQrcode: Boolean(allowUseQrcode), isShow: Boolean(isShow), defaultImgStatus: Boolean(defaultImgStatus),
                isShowImg: Boolean(isShowImg), healthRecordsSwitch: Boolean(healthRecordsSwitch), replaceMallSwitch: Boolean(replaceMallSwitch), bookStatus: Boolean(bookStatus), wsBaseStoreId: wsBaseStoreId || "",
                usedMerchantList: usedMerchantList?.map((el:any) => el.id) || [], tongueApiQps: tongueApiQps ?? undefined,
                homePageType: res.data.homePageType ?? "",
                enableWeigherV2: res.data.enableWeigherV2 ?? 1,
                weigherPresLibName: res.data.weigherPresLibName ?? 1,
                mixYdSymptom: res.data.mixYdSymptom ?? 0,
                // NOTE: 舌诊拍摄方式控制配置，默认值处理
                medicineBrainTongueShootMode: res.data.medicineBrainTongueShootMode ?? 1, // 默认AI智慧屏拍摄
                wsTongueShootMode: res.data.wsTongueShootMode ?? 2, // 默认智慧屏拍摄
            });

            this.storeInfo = cloneDeep(stores)?.map((row) => ({ id: row.storeId, storeName: row.storeName }));
            // 加载展示默认头像门店和头像展示门店（后端返回纯ID数组，需映射门店名称）
            const storeMap = new Map(this.allMerchantStoreList.map((s: any) => [s.id, s.name]));
            this.defaultImgStatusStoreInfo = (res.data.defaultImgStatusStoreIds || []).map((id: number) => ({ id, storeName: storeMap.get(id) || String(id) }));
            this.isShowImgStoreInfo = (res.data.isShowImgStoreIds || []).map((id: number) => ({ id, storeName: storeMap.get(id) || String(id) }));
        })
    }

    setCurUser(cur, key) {
        if (!cur?.id) return;
        this[key].push({ ...cur, userId: cur.id });
        const comparator = (obj1, obj2) => obj1.id === obj2.id;
        this[key] = uniqWith(this[key], comparator)
    }

    handleClose(cur, key) {
        this[key] = this[key].filter((item) => {
            return item.id != cur.id;
        });
    }

    // 点击锚点，平滑滚动到对应分组
    scrollToAnchor(id: string) {
        const box = this.editBoxRef;
        const el = box?.querySelector(`#anchor-${id}`) as HTMLElement | null;
        if (!box || !el) return;
        this.activeAnchor = id;
        // NOTE: 内容不足一屏时无可滚动，直接高亮点击项，避免滚动结束后 scrollspy 重新计算把高亮切回顶部
        if (box.scrollHeight <= box.clientHeight) {
            return;
        }
        this.isAnchorScrolling = true;
        const boxRect = box.getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        const target = box.scrollTop + (rect.top - boxRect.top) - 80;
        box.scrollTo({ top: target, behavior: "smooth" });
        this.resetAnchorScrollTimer();
    }

    onScroll() {
        if (this.isAnchorScrolling) {
            this.resetAnchorScrollTimer();
            return;
        }
        this.updateActiveAnchor();
    }

    updateActiveAnchor() {
        const box = this.editBoxRef;
        if (!box) return;
        const boxRect = box.getBoundingClientRect();
        const threshold = 80;
        let current = this.anchorList[0].id;
        for (const item of this.anchorList) {
            const el = box.querySelector(`#anchor-${item.id}`) as HTMLElement | null;
            if (!el) continue;
            if (el.getBoundingClientRect().top <= boxRect.top + threshold) {
                current = item.id;
            }
        }
        this.activeAnchor = current;
    }

    resetAnchorScrollTimer() {
        if (this.anchorScrollTimer) clearTimeout(this.anchorScrollTimer);
        this.anchorScrollTimer = window.setTimeout(() => {
            this.isAnchorScrolling = false;
            this.anchorScrollTimer = null;
            this.updateActiveAnchor();
        }, 150);
    }

    // 校验不通过时滚动到第一个错误项，避免必填提示在可视区域外
    scrollToFormError() {
        this.$nextTick(() => {
            const box = this.editBoxRef;
            const el = box?.querySelector(".el-form-item.is-error") as HTMLElement | null;
            if (!box || !el) return;
            const boxRect = box.getBoundingClientRect();
            const rect = el.getBoundingClientRect();
            // 已完整处于可视区域时不滚动，避免无谓跳动
            if (rect.top >= boxRect.top && rect.bottom <= boxRect.bottom) return;
            this.isAnchorScrolling = true;
            const target = box.scrollTop + (rect.top - boxRect.top) - 80;
            box.scrollTo({ top: Math.max(target, 0), behavior: "smooth" });
            this.resetAnchorScrollTimer();
        });
    }

    dialogClose() {
        this.storeInfo = []; // 关联门店数据
        this.defaultImgStatusStoreInfo = [];
        this.isShowImgStoreInfo = [];
        this.defaultImgStoreShowCount = 20;
        this.isShowImgStoreShowCount = 20;
        this.formData = cloneDeep(initFormData);
        this.validateFormRef.resetFields();
        this.HomeInstance.tabRemove("merchantInterfaceManage");
    }

    dialogConfirm() {
        if (this.formData.defaultImgStatus && this.formData.defaultImgUrl.length == 0) {
            this.$message.error("请上传默认头像");
            return;
        }
        this.confirmCall();
    }

    getUsedMerchantList() {
        const totalMap = _.keyBy(this.allMerchantOptions, 'id');
        const result = this.formData.usedMerchantList.map(id => totalMap[id]).filter(Boolean)
        return result;
    }

    confirmCall() {
        this.validateFormRef.validate().then(() => {
            const params = {
                ...this.formData,
                stores: cloneDeep(this.storeInfo)?.map((row) => ({ storeId: row.id, storeName: row.storeName })),
                status: Number(this.formData.status),
                autoRegisterUser: Number(this.formData.autoRegisterUser),
                allowUseQrcode: Number(this.formData.allowUseQrcode),
                isShow: Number(this.formData.isShow),
                choiceMerchantId: this.formData.useCustomPres == 2 ? this.formData.choiceMerchantId : "",
                defaultImgStatus: Number(this.formData.defaultImgStatus),
                isShowImg: Number(this.formData.isShowImg),
                defaultImgStatusStoreIds: this.formData.defaultImgStatus ? this.defaultImgStatusStoreInfo.map((row: any) => row.id) : [],
                isShowImgStoreIds: this.formData.isShowImg ? this.isShowImgStoreInfo.map((row: any) => row.id) : [],
                defaultImgUrl: this.formData.defaultImgUrl[0]?.url || "",
                logoImgUrl: this.formData.logoImgUrl[0]?.url || "",
                chineseMedicineLogo: this.formData.chineseMedicineLogo[0]?.url || "",
                backgroundImgUrl: this.formData.backgroundImgUrl[0]?.url || "",
                appImgUrl: this.formData.appImgUrl[0]?.url || "",
                healthRecordsSwitch: Number(this.formData.healthRecordsSwitch),
                replaceMallSwitch: Number(this.formData.replaceMallSwitch),
                insteadMenu: this.formData.replaceMallSwitch ? this.formData.insteadMenu : "",
                insteadAddress: this.formData.replaceMallSwitch ? this.formData.insteadAddress : "",
                bookStatus: Number(this.formData.bookStatus),
                wsUseBaseStore: Number(this.formData.wsUseBaseStore),
                wsSymptom: Number(this.formData.wsSymptom),
                mixSySymptom: Number(this.formData.mixSySymptom),
                enableWeigherV2: Number(this.formData.enableWeigherV2),
                weigherPresLibName: this.formData.enableWeigherV2 === 1 ? Number(this.formData.weigherPresLibName) : "",
                mixYdSymptom: this.formData.enableWeigherV2 === 0 ? Number(this.formData.mixYdSymptom) : "",
                symptomsForPres: Number(this.formData.symptomsForPres),
                usedMerchantList: this.getUsedMerchantList(),
                wsAppBackImg: this.formData.wsAppBackImg[0]?.url || "",
                wsBigTitleImg: this.formData.wsBigTitleImg[0]?.url || "",
                wsRatioImg: this.formData.wsRatioImg[0]?.url || "",
                wsTopImg: this.formData.wsTopImg[0]?.url || "",

                wsMainLogo: this.formData.wsMainLogo[0]?.url || "",
                wsBgImg: this.formData.wsBgImg[0]?.url || "",
                wsCountImg: this.formData.wsCountImg[0]?.url || "",
                wsTongueImg: this.formData.wsTongueImg[0]?.url || "",

                tongueApiQps: this.formData.tongueApiQps ?? null,

                // NOTE: 舌诊拍摄方式控制配置
                medicineBrainTongueShootMode: Number(this.formData.medicineBrainTongueShootMode),
                wsTongueShootMode: Number(this.formData.wsTongueShootMode),
            }
            this.saveLoading = true;
            saveOrUpdateMerchant(params).then(() => {
                this.dialogClose();
                this.$message.success("保存成功");
            }).finally(() => {
                this.saveLoading = false;
            })
        }, () => {
            this.scrollToFormError();
        });
    }
}
